import React from 'react'
import { Link } from 'react-router-dom'
import { useUserAuth } from '../context/UserAuthContext'
import profile from '../assets/customer2.png'

const Account = () => {

  const { user, logOut } = useUserAuth();
  const handleClick = async () => {
    try {
      await logOut();
    } catch (err) {
      console.log(err.message);
    }
  }

  return (
    <div className='w-full h-screen flex flex-col items-center justify-center'>
      <div className='sm:w-[420px] sm:h-[420px] w-auto h-auto shadow-lg flex flex-col items-center justify-center gap-10 sm:p-0 p-8  bg-white'>
        <img src={profile} alt="userProfile" width={90}/>
        <h2 className='text-xl'>Welcome <span className='font-semibold'>{user.email}</span></h2>
        <button className='border-2 border-black bg-black text-white px-4 py-2 mb-3 mt-4 w-[220px] font-medium' onClick={handleClick}><Link to='/'>Logout</Link></button>
      </div>
    </div>
  )
}

export default Account